@if (hasCountries()) {
  <div class="mt-4">
    @if (heading()) {
      <h3 class="text-lg font-semibold mb-2">{{ heading() }}</h3>
    }
    <ul class="list-none">
      @for (country of countries(); track country.isoCode) {
        <li class="flex items-center mb-1">
          <img
            [src]="getCountryFlagUrl(country.isoCode)"
            alt="{{ getCountryDisplayName(country) }}"
            class="w-5 h-3 mr-2"
          />
          <span>{{ getCountryDisplayName(country) }}</span>
        </li>
      }
    </ul>
  </div>
}
